import { render, staticRenderFns } from "./ReactivationStatus.vue?vue&type=template&id=4b3f55d6&scoped=true"
import script from "./ReactivationStatus.vue?vue&type=script&lang=js"
export * from "./ReactivationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f55d6",
  null
  
)

export default component.exports